import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Suspense } from 'react';

import { RumComponentContextProvider } from '@mint-lib/datadog';
import { useTranslation } from '@mint-lib/i18n';
import { QueryClientProvider } from '@mint-lib/query-client';
import { useService } from '@mint-lib/routing-context';
import { SlotPortal } from '@mint-lib/slots';
import { Outlet } from '@mint/routing';

import { MainLayout } from '../components/atoms/MainLayout.jsx';
import { CustomMetricsDrawer } from '../components/organisms/CustomMetricsDrawer.jsx';
import { CustomMetricsDrawerProvider } from '../contexts/CustomMetricsContext.jsx';

export function ImportHubLayout() {
  const { t } = useTranslation('@myn/import-hub');

  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  return (
    <Suspense>
      <RumComponentContextProvider componentArea="import-hub">
        <QueryClientProvider client={queryClient}>
          <CustomMetricsDrawerProvider>
            <MainLayout>
              <SlotPortal name="topBarTitle">{t('Data Import Hub')}</SlotPortal>
              <Outlet />
              <CustomMetricsDrawer />
            </MainLayout>
          </CustomMetricsDrawerProvider>
          <ReactQueryDevtools initialIsOpen={true} />
        </QueryClientProvider>
      </RumComponentContextProvider>
    </Suspense>
  );
}
